<script setup lang="ts">
// A 44 px field with 16 px text (so iOS doesn't zoom), under an uppercase label.
// Other attributes (name, autocomplete, required…) go to the <input>.
defineOptions({ inheritAttrs: false });
withDefaults(
  defineProps<{
    modelValue?: string | number;
    label?: string | undefined;
    placeholder?: string | undefined;
    type?: string;
  }>(),
  { modelValue: '', label: '', placeholder: '', type: 'text' },
);
const emit = defineEmits<{ 'update:modelValue': [value: string] }>();
</script>

<template>
  <label class="itc-field">
    <span v-if="label" class="itc-field-label">{{ label }}</span>
    <input
      v-bind="$attrs"
      class="itc-input"
      :type="type"
      :value="modelValue"
      :placeholder="placeholder"
      @input="emit('update:modelValue', ($event.target as HTMLInputElement).value)"
    />
  </label>
</template>
